export const DATA_ACQUISITION_STATUS = {
  LOW: "LOW",
  MEDIUM: "MEDIUM",
  HIGH: "HIGH",
};

export const minLoadingTimeInMillisecondsDefault = 10000;

export const minLoadingTimeInMilliseconds = {
  CONTACT_EMAIL: 10000,
  INIT: 10000,
  BOOK: 10000,
  BOOK_INFO: 10000,
  BOOK_CONTENT: 10000,
  FOLDER_LIST: 10000,
  BOOKS_LIST: 10000,
  CURRENT_FOLDER: 10000,
  SUBSCRIPTION_CONTENT: 10000,
  THOUGHT_CONTENT: 10000,
  NEWS_CONTENT: 10000,
  SEARCH_FILTER_CONTENT: 10000,
  HISTORY: 10000,
  SC_PREVIEW: 10000,
};

export const LOADING_TYPES = {
  INIT: "INIT",
  BOOK: "BOOK",
  BOOK_INFO: "BOOK_INFO",
  BOOK_CONTENT: "BOOK_CONTENT",
  BOOK_DATA: "BOOK_DATA",
  FOLDER_LIST: "FOLDER_LIST",
  BOOKS_LIST: "BOOKS_LIST",
  BOOKS_IN_TRANSLATIONS: "BOOKS_IN_TRANSLATIONS",
  CURRENT_FOLDER: "CURRENT_FOLDER",
  SUBSCRIPTION_CONTENT: "SUBSCRIPTION_CONTENT",
  THOUGHT_CONTENT: "THOUGHT_CONTENT",
  NEWS_CONTENT: "NEWS_CONTENT",
  CONTACT_EMAIL: "CONTACT_EMAIL",
  SEARCH_FILTER_CONTENT: "SEARCH_FILTER_CONTENT",
  FEATURED_SEARCH_SECTIONS: "FEATURED_SEARCH_SECTIONS",
  HISTORY: "HISTORY",
  SC_PREVIEW: "SC_PREVIEW",
};
